module.exports = __webpack_public_path__ + "img/Installation_map.14dd4d64.jpg";